(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["header"]) return;
  try {
    
  class StickyHeader extends HTMLElement {
    constructor() {
      super();
    }

    connectedCallback() {
      this.header = document.querySelector('.section-header');
      this.headerIsAlwaysSticky =
        this.getAttribute('data-sticky-type') === 'always' ||
        this.getAttribute('data-sticky-type') === 'reduce-logo-size';
      this.headerBounds = {};

      this.setHeaderHeight();

      window.matchMedia('(max-width: 990px)').addEventListener('change', this.setHeaderHeight.bind(this));

      if (this.headerIsAlwaysSticky) {
        this.header.classList.add('shopify-section-header-sticky');
      }

      this.currentScrollTop = 0;
      this.preventReveal = false;
      this.predictiveSearch = this.querySelector('predictive-search');

      this.onScrollHandler = this.onScroll.bind(this);
      this.hideHeaderOnScrollUp = () => (this.preventReveal = true);

      this.addEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.addEventListener('scroll', this.onScrollHandler, false);

      this.createObserver();
    }

    setHeaderHeight() {
      document.documentElement.style.setProperty('--header-height', `${this.header.offsetHeight}px`);
    }

    disconnectedCallback() {
      this.removeEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.removeEventListener('scroll', this.onScrollHandler);
    }

    createObserver() {
      let observer = new IntersectionObserver((entries, observer) => {
        this.headerBounds = entries[0].intersectionRect;
        observer.disconnect();
      });

      observer.observe(this.header);
    }

    onScroll() {
      const scrollTop = window.pageYOffset || document.documentElement.scrollTop;

      if (this.predictiveSearch && this.predictiveSearch.isOpen) return;

      if (scrollTop > this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (this.preventHide) return;
        requestAnimationFrame(this.hide.bind(this));
      } else if (scrollTop < this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (!this.preventReveal) {
          requestAnimationFrame(this.reveal.bind(this));
        } else {
          window.clearTimeout(this.isScrolling);

          this.isScrolling = setTimeout(() => {
            this.preventReveal = false;
          }, 66);

          requestAnimationFrame(this.hide.bind(this));
        }
      } else if (scrollTop <= this.headerBounds.top) {
        this.header.classList.remove('scrolled-past-header');
        requestAnimationFrame(this.reset.bind(this));
      }

      this.currentScrollTop = scrollTop;
    }

    hide() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-hidden', 'shopify-section-header-sticky');
      this.closeMenuDisclosure();
      this.closeSearchModal();
    }

    reveal() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-sticky', 'animate');
      this.header.classList.remove('shopify-section-header-hidden');
    }

    reset() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.remove('shopify-section-header-hidden', 'shopify-section-header-sticky', 'animate');
    }

    closeMenuDisclosure() {
      this.disclosures = this.disclosures || this.header.querySelectorAll('header-menu');
      this.disclosures.forEach((disclosure) => disclosure.close());
    }

    closeSearchModal() {
      this.searchModal = this.searchModal || this.header.querySelector('details-modal');
      this.searchModal.close(false);
    }
  }

  customElements.define('sticky-header', StickyHeader);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["walkesim-hero-search"] && !Shopify.designMode) return;
  try {
    
  document.addEventListener('input', function(event) {
    var input = event.target.closest('[data-walkesim-hero-input]');
    if (!input) return;

    var section = input.closest('[data-walkesim-hero-search]');
    var results = section.querySelector('[data-walkesim-hero-results]');
    var items = section.querySelectorAll('[data-walkesim-result]');
    var empty = section.querySelector('[data-walkesim-hero-empty]');
    var query = input.value.trim().toLowerCase();
    var shown = 0;

    if (!query) {
      results.hidden = false;
      items.forEach(function(item, index) {
        item.hidden = index >= 8;
      });
      empty.hidden = true;
      return;
    }

    results.hidden = false;
    items.forEach(function(item) {
      var match = item.getAttribute('data-search-text').indexOf(query) !== -1;
      item.hidden = !match;
      if (match) shown += 1;
    });
    empty.hidden = shown !== 0;
  });

  document.addEventListener('focusin', function(event) {
    var input = event.target.closest('[data-walkesim-hero-input]');
    if (!input) return;

    var section = input.closest('[data-walkesim-hero-search]');
    var results = section.querySelector('[data-walkesim-hero-results]');
    var items = section.querySelectorAll('[data-walkesim-result]');
    results.hidden = false;
    items.forEach(function(item, index) {
      item.hidden = index >= 8;
    });
  });

  document.addEventListener('click', function(event) {
    var section = event.target.closest('[data-walkesim-hero-search]');
    document.querySelectorAll('[data-walkesim-hero-results]').forEach(function(results) {
      if (!section || !results.closest('[data-walkesim-hero-search]').isSameNode(section)) {
        results.hidden = true;
      }
    });

    var submit = event.target.closest('[data-walkesim-hero-submit]');
    if (!submit) return;

    var wrap = submit.closest('[data-walkesim-hero-search]');
    var input = wrap.querySelector('[data-walkesim-hero-input]');
    var visibleItems = Array.prototype.filter.call(wrap.querySelectorAll('[data-walkesim-result]'), function(item) {
      return !item.hidden;
    });
    var firstVisible = visibleItems[0];
    var query = input ? input.value.trim() : '';

    if (!query) {
      window.location.href = '/collections/all';
      return;
    }

    if (firstVisible) {
      window.location.href = firstVisible.href;
      return;
    }

    if (query) {
      window.location.href = '/search?q=' + encodeURIComponent(query + ' eSIM');
    }
  });

  document.addEventListener('keydown', function(event) {
    var input = event.target.closest('[data-walkesim-hero-input]');
    if (!input || event.key !== 'Enter') return;

    event.preventDefault();
    var section = input.closest('[data-walkesim-hero-search]');
    var submit = section.querySelector('[data-walkesim-hero-submit]');
    if (submit) submit.click();
  });

  } catch(e) { console.error(e); }
})();
})();
